import {
  LISTAR_AGENDAMENTOS,
  SELECIONAR_AGENDAMENTO,
  LISTAR_ROTAS,
  GET_ALL_OPERADORES,
  LISTAR_RAMAIS,
  GET_SPECIFIC_OPERADOR,
  GET_ALL_DEPARTAMENTS,
  GET_SPECIFIC_DEPARTAMENT,
  LISTAR_GRUPOS_DE_ROTAS
} from './mutation-types'

import agendamentosHttpService from '../_services/AgendamentosHttpService'

export default {
  listarAgendamentos: async ({ commit }) => {
    try {
      const response = await agendamentosHttpService.gettarefas()
      commit(LISTAR_AGENDAMENTOS, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  selecionarAgendamento: async ({ commit }, _id) => {
    try {
      const response = await agendamentosHttpService.gettarefa(_id)
      commit(SELECIONAR_AGENDAMENTO, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarRotas: async ({ commit }) => {
    try {
      const response = await agendamentosHttpService.getrotas()
      commit(LISTAR_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarOperadores: async ({ commit }) => {
    try {
      const response = await agendamentosHttpService.getOperadores()
      commit(GET_ALL_OPERADORES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRamais: async ({ commit }) => {
    try {
      const response = await agendamentosHttpService.getRamais()
      commit(LISTAR_RAMAIS, response.data.ramais)
    } catch (e) {
      console.log(e)
    }
  },
  listarOperadorEspecifico: async ({ commit }, id) => {
    try {
      const response = await agendamentosHttpService.getOperador(id)
      commit(GET_SPECIFIC_OPERADOR, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarDepartamentos: async ({ commit }) => {
    try {
      const response = await agendamentosHttpService.getDepartaments()
      commit(GET_ALL_DEPARTAMENTS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarDepartamentoEspecifico: async ({ commit }, id) => {
    try {
      const response = await agendamentosHttpService.getDepartament(id)
      commit(GET_SPECIFIC_DEPARTAMENT, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGruposDeRotas: async ({ commit }) => {
    try {
      const response = await agendamentosHttpService.getGruposDeRotas()
      commit(LISTAR_GRUPOS_DE_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  }
}
